export const downloadFile = ( data, fileName, fileType ) => {
    const a = document.createElement('a')
    a.download = fileName;
    a.href = `data:${fileType};base64,${data}`
    const clickEvt = new MouseEvent('click', {
      view: window,
      bubbles: true,
      cancelable: true,
    })
    a.dispatchEvent(clickEvt)
    a.remove()
  }

export const isJsonString = (str) => {
  try {
      JSON.parse(str);
      return true;
  } catch (e) {
      return false;
  }
}